import React from 'react';

import { ExclamationWarningIcon, ResetIcon } from '../../../icons';
import { colors } from '../../../constants';

const MarketError = ({ onRetry }) => {
    const handleRetry = () => onRetry();

    return (
        <div className="d-inline-flex align-items-center gap-4">
            <div className="d-flex align-items-center gap-2">
                <ExclamationWarningIcon color={colors.aroRed} size={36} />
                <p className="fs-5 mb-0">Timeout retrieving data</p>
            </div>
            <button
                className="btn p-1 rounded d-flex align-items-center"
                style={{
                    background: colors.goldwood,
                    color: 'white',
                }}
                onClick={handleRetry}
            >
                <span>Retry</span>
                <ResetIcon color="white" size="16px" />
            </button>
        </div>
    );
};

export default MarketError;
